import {
  GET_POLICY_VALIDATE_ERROR,
  GET_POLICY_VALIDATE_SUCCESS,
  GET_POLICY_VALIDATE_REQUEST,
} from '../../constants/customPaymentActionNames';
import { statusOk } from '../../utils/variables';

export const initialState = {
  isPending: false,
  isError: false,
  isSuccess: false,
  response: null,
  error: null,
};

function customPaymentReducer(state = initialState, action) {
  switch (action.type) {
    case GET_POLICY_VALIDATE_REQUEST:
      return {
        ...state,
        isPending: true,
        isError: false,
        isSuccess: false,
      };
    case GET_POLICY_VALIDATE_SUCCESS: {
      const response = action?.payload;
      console.log('response: ', response);
      const isError = response?.responseType !== statusOk;
      const policyDetails = response?.payload;
      response.payload = null;

      return {
        ...state,
        isPending: false,
        isError,
        isSuccess: true,
        policyDetails,
      };
    }
    case GET_POLICY_VALIDATE_ERROR:
      return {
        ...state,
        isPending: false,
        isError: true,
        isSuccess: false,
      };
    default:
      return state;
  }
}
export default customPaymentReducer;
